import type {
  ExistingCustomerIntent,
  FirstAction,
  FirstActionItem,
  JobRole,
  ReasonToUseLaunchDarkly,
} from '@gonfalon/get-started/types';
import type { SdkKey } from '@gonfalon/sdk-info/sdkInfo';

// Re-export types from get-started for backward compatibility
export { firstActions, jobRoles, jobRolesList } from '@gonfalon/get-started/types';
export type { FirstAction, FirstActionItem, JobRole };

/**
 * @deprecated Please use the SdkKey type from packages/sdk-info
 */
export type SdkKebabName = SdkKey;

export type OnboardingPath = 'flags' | 'experiments' | 'ai-configs' | 'observability';
export type AIConfigSDKChoice = 'python' | 'javascript' | 'dotnet' | 'go' | 'ruby';

export type OnboardingFlag = {
  flagKey: string;
  flagName: string;
  flagOn: boolean;
};

export type OnboardingAiConfig = {
  aiConfigName: string;
  aiConfigKey: string;
};

export type OnboardingAiConfigVariation = {
  variationKey: string;
  variationName: string;
};

export type OnboardingValues = {
  sdk: SdkKebabName;
  path: OnboardingPath;
  flags: { createAFlag: OnboardingFlag };
  experiments: { createAFlag: OnboardingFlag };
  'ai-configs': {
    createAiConfig: OnboardingAiConfig;
    selectedSdkType: AIConfigSDKChoice;
    aiConfigVariation: OnboardingAiConfigVariation;
  };
};

/**
 * @deprecated Please use the initKey field in SDK_INFO in /packages/sdk-info
 */
export type SdkInitIdentifierType = {
  [key in SdkKebabName]: 'mobile' | 'clientSideId' | 'sdk' | undefined;
};

/**
 * @deprecated Please use the initKey field in SDK_INFO in /packages/sdk-info
 */
export const SdkInitIdentifier: SdkInitIdentifierType = {
  'akamai-server-edgekv-sdk': 'clientSideId',
  'android-client-sdk': 'mobile',
  'apex-server-sdk': 'sdk',
  'cloudflare-server-sdk': 'clientSideId',
  'cpp-client-sdk': 'mobile',
  'cpp-server-sdk': 'sdk',
  'dotnet-client-sdk': 'mobile',
  'dotnet-server-sdk': 'sdk',
  'electron-client-sdk': 'clientSideId',
  'erlang-server-sdk': 'sdk',
  'flutter-client-sdk': 'mobile',
  'go-server-sdk': 'sdk',
  'haskell-server-sdk': 'sdk',
  'ios-client-sdk': 'mobile',
  'java-server-sdk': 'sdk',
  'js-client-sdk': 'clientSideId',
  'lua-server-sdk': 'sdk',
  'node-client-sdk': 'clientSideId',
  'node-server-sdk': 'sdk',
  'php-server-sdk': 'sdk',
  'python-server-sdk': 'sdk',
  'react-client-sdk': 'clientSideId',
  'react-native-client-sdk': 'mobile',
  'roku-client-sdk': 'mobile',
  'ruby-server-sdk': 'sdk',
  'rust-server-sdk': 'sdk',
  'vercel-server-sdk': 'clientSideId',
  'vue-client-sdk': 'clientSideId',
};

export type FormFields = {
  reason?: ReasonToUseLaunchDarkly;
  firstAction?: FirstAction;
  jobRole?: JobRole;
  existingCustomerIntent?: ExistingCustomerIntent;
  rotatingQuestionAnswer?: string | string[];
  rotatingQuestionAnswer2?: string | string[];
  organization?: string;
};
